import {Place} from "../../account/models/Place";

export class NetworkContract {
  id: number;

  client: string;
  clientType;
  clientCode: string;
  clientName: string;
  contractNumber: string;
  contractType: string;
  date: string;
  code: string;
  name: string;

  places: Place[];

}
